<template>
    <div>
        <breadCrumb 
            :icon="'fa-gifts'"
            :category="$t(`sideNav.navSalonReport`)"
            subCategory="Roster"
            :subSubCategory="''">
        </breadCrumb>

        <div v-if="!addToggle" class="text-right mt-3 mr-5">
            <button class="btn buttons-csv buttons-html5 btn-outline-primary" type="button" title="Add Leave" @click="addData">
                <span class="fal fa-plus mr-2"></span>
                <span>Add Leave</span>
            </button>
        </div>

        <div v-if="!addToggle">
            <!-- <ul  class="nav nav-tabs nav-tabs-clean px-3 px-sm-5 mt-3" role="tablist">
                <li class="nav-item" v-for="t in $i18n.messages[$i18n.locale].tab.memberTabLists" :key="t.id">
                    <a class="nav-link bg-transparent fs-lg fw-400" :class="{'active': selectedTab == t.id}" @click="selectedTab = t.id">{{t.text}}</a>
                </li>
            </ul> -->
            <div class="px-3 px-sm-5 py-4">
                <div class="tab-content mt-5">
                    <rosterList
                        ref="dataList"
                        :outlets="outlets"
                        :class="{'active': selectedTab == 'active' || selectedTab == 'hidden' }"
                        class="tab-pane"
                        @onOutletChange="onOutletChange"
                        @editData="editData">
                    </rosterList>
                </div>
            </div>
        </div>

        <dataForm
            ref="dataForm"
            :leaveTypes="leaveTypes"
            :staffs="staffs"
            :outlets="outlets"
            @onModalClose="onDataFormClose">
        </dataForm>

        <div v-if="showSpinner" class="d-flex justify-content-center mt-3 mb-3">
            <b-spinner label="Loading..."></b-spinner>
        </div>
    </div>
</template>
<script>
import BreadCrumb from './../../Bread_Crumb'
import dataForm from './Roster_Form'
import RosterList from './Roster_List'
import { handleSessionExpired } from './../../../../assets/js/dashboard/dashboard'

export default {
    name: 'menuReportRoster',
    components:{
        BreadCrumb,
        dataForm, 
        RosterList, 
    },
    data(){
        let selectedtab = this.$i18n.messages[this.$i18n.locale].tab.memberTabLists[0].id
        return{
            showSpinner: false,

            addToggle: false,
            selectedTab: selectedtab,
            
            memberLists: [], 
            outlets:[],
            staffs: [],
            leaveTypes: [],
        }
    },
    watch:{
        selectedTab(value){
            if(value == "active" || value == "hidden"){
                this.$refs.memberList.filterMemberByView(value);
            }
        },
    },
    methods:{
        returnMemberList(){
            this.addToggle = false;
        },

        loadStaff() {
            this.showSpinner = true
            this.loadStaffImpl()
        },
        async loadStaffImpl() {
            const url = "https://staff.tunai.io/business/staff/"

            await this.$axios({
                method: 'get',
                url: url,
                headers: { token: this.$util.getSessionToken() }
            })
            .then((response) => {
                this.staffs = []

                for(let staff of response.data['staffs']) {
                    this.staffs.push(staff)
                }
            })
            .catch((err) => {
                if (err && err.response && err.response.data && err.response.data.error == this.$api.INVALID_TOKEN) {
                    handleSessionExpired();
                }
            })
            .finally(() => {
                if(this.leaveTypes.length > 0 && this.staffs.length > 0) {
                    this.showSpinner = false
                }
            })
        },

        loadLeaveType() {
            this.showSpinner = true
            this.loadLeaveTypeImpl()
        },
        async loadLeaveTypeImpl() {
            const url = "https://staff.tunai.io/business/staff/leaves/type"

            await this.$axios({
                method: 'get',
                url: url,
                headers: { token: this.$util.getSessionToken() }
            })
            .then((response) => {
                this.leaveTypes = []

                for(let type of response.data['type']) {
                    this.leaveTypes.push(type)
                }
            })
            .catch((err) => {
                if (err && err.response && err.response.data && err.response.data.error == this.$api.INVALID_TOKEN) {
                    handleSessionExpired();
                }
            })
            .finally(() => {
                if(this.leaveTypes.length > 0 && this.staffs.length > 0) {
                    this.showSpinner = false
                }
            })
        },

        onOutletChange(val) {
            this.filterOutlet = val
        },

        addData() {
            this.$refs.dataForm.show(this.filterOutlet)
        },
        editData(item) {
            let staff = this.staffs.find(k => k['staffID'] === item['staffID'])
            let outlet = this.outlets.find(k => k['id'] === staff['outletID'])
            this.$refs.dataForm.show(outlet, item)
        },
        onDataFormClose() {
            this.$refs.dataList.loadData()
        },
    },
    mounted(){
        this.outlets = JSON.parse(this.$store.state.outlets);
        this.outlets.unshift({ id: "all", text: this.$i18n.t('label.all', { 'item': this.$i18n.t('label.outlet') }) })
        this.filterOutlet = this.outlets[0];

        this.loadStaff()
        this.loadLeaveType()
    },
}
</script>